module.exports = __webpack_public_path__ + "static/media/Table-chevron-right.66106b37.svg";